import SEO from "../common/SEO";
import ColorSwitcher from "../elements/switcher/ColorSwitcher";
import { Link } from "react-router-dom";

const ErrorPage = () => {
  return (
    <>
      <style>
        {`
          .text-green {
            color: #006600 !important;
          }
          
          .coming-soon-area {
            min-height: 100vh;
            background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
            position: relative;
            overflow: hidden;
            display: flex;
            align-items: center;
          }
          
          .thankyou-container {
            display: flex;
            align-items: center;
            justify-content: center;
            gap: 100px;
            padding: 20px;
            max-width: 1200px;
            margin: 0 auto;
          }
          
          .thumbnail {
            max-width: 600px;
            flex: 0 0 auto;
          }
          
         .thumbnail img {
            width: 100%;
            height: auto;
            border-radius: 15px;
            box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
            transition: transform 0.3s ease;
            display: block;
            object-fit: contain;
          }
          
          .thumbnail:hover img {
            transform: translateY(-5px);
          }
          
          .continue-button {
            padding: 12px 40px;
            background: #6600cc;
            color: white;
            border: none;
            border-radius: 25px;
            font-weight: 600;
            text-transform: uppercase;
            letter-spacing: 1px;
            transition: all 0.3s ease;
            box-shadow: 0 5px 15px rgba(0, 102, 0, 0.3);
            min-width: 200px;
            white-space: nowrap;
            text-align: center;
          }
          
          .continue-button:hover {
            background: #006600;
            transform: translateY(-2px);
            box-shadow: 0 8px 20px rgba(0, 102, 0, 0.4);
          }
          
          .site-logo {
            padding: 20px 0;
            animation: fadeIn 1s ease-in;
            text-align: center;
          }
          
          .shape {
            opacity: 0.7;
            transition: all 0.3s ease;
          }
          
          .shape:hover {
            opacity: 1;
            transform: scale(1.1);
          }
          
          @keyframes fadeIn {
            from {
              opacity: 0;
              transform: translateY(-20px);
            }
            to {
              opacity: 1;
              transform: translateY(0);
            }
          }

          @media (min-width: 992px) {
            .thankyou-container {
              min-height: calc(100vh - 120px); /* Adjust based on logo height */
            }
          }

          @media (max-width: 991px) {
            .thankyou-container {
              flex-direction: column;
              gap: 40px;
              text-align: center;
              padding: 40px 20px;
            }
            
            .thumbnail {
              max-width: 100%;
            }
            
            .continue-button {
              margin-top: 0;
            }
          }

          @media (max-width: 576px) {
            .thankyou-container {
              padding: 30px 15px;
              gap: 20px;
            }
            
            .site-logo img {
              max-width: 120px;
            }
            
            .continue-button {
              padding: 10px 30px;
              min-width: 150px;
            }
            
            .thumbnail {
              max-width: 100%;
            }
          }
        `}
      </style>
      <SEO />
      <ColorSwitcher />
      <main className="main-wrapper">
        <div className="coming-soon-area onepage-screen-area">
          <div className="container">
            <div className="row align-items-center justify-content-center">
              <div className="col-12">
                <div className="site-logo">
                  <Link
                    to={process.env.PUBLIC_URL + "/"}
                    className="logo-light">
                    <img
                      src={process.env.PUBLIC_URL + "/images/logo.png"}
                      alt="Logo"
                    />
                  </Link>
                  <Link to={process.env.PUBLIC_URL + "/"} className="logo-dark">
                    <img
                      src={process.env.PUBLIC_URL + "/images/logo.png"}
                      alt="Logo"
                    />
                  </Link>
                </div>
              </div>
              <div className="col-xl-8 col-lg-10 col-12">
                <div className="thankyou-container">
                  <div className="thumbnail">
                    <img
                      src={
                        process.env.PUBLIC_URL + "/images/404/construction.jpg"
                      }
                      alt="Construction"
                    />
                  </div>
                  <Link to={process.env.PUBLIC_URL + "/"}>
                    <button className="continue-button">Keep Clifing!</button>
                  </Link>
                </div>
              </div>
            </div>
          </div>
          <ul className="shape-group-8 list-unstyled">
            <li className="shape shape-2">
              <img
                src={process.env.PUBLIC_URL + "/images/others/bubble-28.png"}
                alt="Bubble"
              />
            </li>
            <li className="shape shape-3">
              <img
                src={process.env.PUBLIC_URL + "/images/others/line-4.png"}
                alt="Line"
              />
            </li>
          </ul>
        </div>
      </main>
    </>
  );
};

export default ErrorPage;
